import { BreadcrumbsForFooter } from "@/components/Breadcrumbs";
import Copyrights from "@/components/Copyrights";
import {
  companyLink,
  helpLink,
  maintenanceLink,
  privacyLink,
} from "@/lib/constants";
import styles from "@/styles/Footer.module.scss";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useMemo } from "react";

function FooterLink(props) {
  const { wrapperClass, linkClass, children, ...linkProps } = props;
  return (
    <li className={classnames(styles.wrapper, wrapperClass)}>
      <a className={classnames(styles.link)} {...linkProps}>
        {children}
      </a>
    </li>
  );
}

function FooterUpper({ isLoginPage }) {
  if (isLoginPage) return null;
  const help = useMemo(() => helpLink(), []);
  const maintenance = useMemo(() => maintenanceLink(), []);
  return (
    <div className={`${styles.box} ${styles.upper}`}>
      <ul className={styles.links}>
        {/* TODO: 変更 */}
        <FooterLink href={help} target="_blank" rel="noopener noreferrer">
          ヘルプ
        </FooterLink>
        <FooterLink href="/static/feature/constant/environment">
          動作環境
        </FooterLink>
        {/*<FooterLink href="/inquiry">お問い合わせ</FooterLink>*/}
        <FooterLink href={maintenance}>メンテナンス情報</FooterLink>
      </ul>
    </div>
  );
}

function FooterLower({}) {
  const privacy = useMemo(() => privacyLink(), []);
  const year = new Date().getFullYear();
  const company = useMemo(() => companyLink(), []);

  return (
    <div className={`${styles.box} ${styles.lower}`}>
      <ul className={styles.links}>
        <FooterLink href={company} target="_blank" rel="noopener noreferrer">
          会社概要
        </FooterLink>
        {/* TODO: 変更 */}
        <FooterLink href="/static/legal/service_term">
          スカパー！動画ストア利用規約
        </FooterLink>

        <FooterLink href={privacy} target="_blank" rel="noopener noreferrer">
          プライバシーポリシー
        </FooterLink>
        <FooterLink href="/static/legal/sct_law">
          特定商取引法に基づく表記（返品特約含む）
        </FooterLink>
        <FooterLink href="/static/legal/site_policy">サイトポリシー</FooterLink>
      </ul>

      <p className={styles.copyright}>
        COPYRIGHT © 2011-{year} SKY PERFECT JSAT CORPORATION ALL RIGHTS
        RESERVED.
      </p>

      <Copyrights />
    </div>
  );
}

function Footer() {
  const router = useRouter();
  const isLoginPage = (() => {
    return router.pathname == "/login";
  })();

  return (
    <footer className={styles.footer} role="contentinfo">
      <BreadcrumbsForFooter />
      <FooterUpper {...{ isLoginPage }} />
      <FooterLower {...{}} />
    </footer>
  );
}

export default Footer;
